import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Result, Button } from "antd";

import { POST } from "../../../providers/useAxiosQuery";
import { apiUrl, encrypt, logo } from "../../../providers/companyInfo";

export default function PageAuthHandoff() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [error, setError] = useState("");
	const hasExchangedRef = useRef(false);

	const { mutate: mutateExchange } = POST(
		"api/exchange_auth_handoff",
		"exchange_auth_handoff",
	);

	useEffect(() => {
		if (hasExchangedRef.current) {
			return;
		}

		const code = searchParams.get("code");

		if (!code) {
			setError("Missing handoff code");
			return;
		}

		hasExchangedRef.current = true;

		let data = {
			code: code,
		};

		mutateExchange(data, {
			onSuccess: (res) => {
				if (res.success && res.data && res.token) {
					localStorage.token = res.token;
					localStorage.userdata = encrypt(JSON.stringify(res.data));
					// Full reload so route guards read the new token (they are not reactive).
					window.location.replace("/dashboard");
				} else {
					hasExchangedRef.current = false;
					setError(res.message || "Handoff failed");
				}
			},
			onError: () => {
				hasExchangedRef.current = false;
				setError("Handoff failed");
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (error) {
		return (
			<div
				style={{
					height: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Result
					status="error"
					title="Sign-In Failed"
					subTitle={error}
					extra={
						<Button type="primary" onClick={() => navigate("/")}>
							Back to Login
						</Button>
					}
				/>
			</div>
		);
	}

	return (
		<div className="splash-centered">
			<img width="180" src={apiUrl(logo)} alt="logo" />
			<div className="splash-loader">
				<div className="splash-inner one"></div>
				<div className="splash-inner two"></div>
				<div className="splash-inner three"></div>
			</div>
		</div>
	);
}
